// namespace (소문자)
export const NAMESPACE = 'banner';

//getters

//actions
export const CLICK_VIEW_BANNER = 'CLICK_VIEW_BANNER';

//mutations
